import { useNavigate } from 'react-router-dom';

/** When footer links are clicked, render the page at 0, 0. **/

export const useNavigateToTop = () => {
  const navigate = useNavigate();

  const navigateAndReset = (to: string) => {
    navigate(to, { replace: true });
    window.scrollTo(0, 0);
  };

  return navigateAndReset;
};
